import {React} from '@api';
import {usePdfStore} from '@modules/pdf'
import {ProductPageStyledComponents} from './VlpProductPage.styles'

import { styled } from '@pdf';
// import { PdfHeader, IAsicsHeaderProps } from './PdfHeader';
import {ProductPageFooter, ProductPageHeader} from './VlpProductPage'
// import { AsicsPdfFooter,IAsicsPdfFooterProps } from './AsicsPdfFooter';

const CoverPageContainer = styled.View`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-content: flex-start;
  width: 100%;
`

const CenterTitle = styled.View`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-items: flex-start;
  align-self: flex-start;
  justify-content: flex-start;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 12px;
  top: -30px;
  line-height: 1.2;
  letter-spacing: 0;
`

const Title = styled.Text`
  display: flex;
  flex-direction: column;
  font-family: Asics Bold;
  font-size: 40px;
  max-lines: 2;
  text-overflow:ellipsis;
`

const SubTitle = styled.Text`
  font-family: Asics Regular;
  font-size: 25px;
  margin-top: 30px;
  max-lines: 2;
  text-overflow:ellipsis;
`

const Subject = styled.Text`
  font-family: Asics Light;
  font-size: 20px;
  margin-top: 30px;
  max-lines: 2;
  text-overflow:ellipsis;
`
const CoverHeaderLine = styled.View`
  background-color: #808080;;
  text-align: left;
  width: 100%;
  height: 1px;
  margin: 2px 0 0 0;
`

export const CoverPage: React.FunctionComponent<any> = ({ download }) => {

  const {  versions, renderPage, selectedPageSize, selectedPdfDocument: {subject, title, size, orientation, subtitle} } = usePdfStore(),
    {MyReportPage} = ProductPageStyledComponents()

  return (
    <MyReportPage size={size} orientation={orientation ?? 'landscape'} hideTitle wrap={false} /*ruler={DEBUG} rulerSteps={8}*/ >
      <ProductPageHeader/>
      <CoverHeaderLine/>
      <CoverPageContainer>
        <CenterTitle>
          <Title>{_.upperCase(title)}</Title>
          <SubTitle>{_.upperCase(subtitle)}</SubTitle>
          <Subject>{_.upperCase(subject)}</Subject>
        </CenterTitle>
      </CoverPageContainer>
      <ProductPageFooter index={0} download={download}/>
    </MyReportPage>
  )

  /*return (renderPage({
    hideTitle: true,
    size,
    orientation,
    children: <Fragment>
      <ProductPageHeader />
      <CoverHeaderLine />
      <CoverPageContainer>
        <CenterTitle>
          <Title>{_.upperCase(title)}</Title>
          <SubTitle>{_.upperCase(subtitle)}</SubTitle>
          <Subject>{_.upperCase(subject)}</Subject>
        </CenterTitle>
      </CoverPageContainer>
      <ProductPageFooter index={0} download={download} />
    </Fragment>
  }) as any)*/
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/CoverPage.tsx